module.exports = __webpack_public_path__ + "static/img/3_7_1.0a8f1efa.jpg";